export default __webpack_public_path__ + "static/media/stickers.d5d3db8f.svg";